var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.2129,
    r: 14.5,
    transform: "rotate(90 15 15.2129)",
    fill: "#FF3407",
    stroke: "#FF3407"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2426 13.1725C19.6332 12.782 19.6332 12.1488 19.2426 11.7583C18.8521 11.3677 18.219 11.3677 17.8284 11.7583L16.4142 13.1725C15.6332 13.9535 14.3668 13.9535 13.5858 13.1725L12.1716 11.7583C11.781 11.3677 11.1479 11.3677 10.7574 11.7583C10.3668 12.1488 10.3668 12.782 10.7574 13.1725L12.1716 14.5867C12.9526 15.3677 12.9526 16.6341 12.1716 17.4151L10.7574 18.8293C10.3668 19.2199 10.3668 19.853 10.7574 20.2435C11.1479 20.6341 11.781 20.6341 12.1716 20.2435L13.5858 18.8293C14.3668 18.0483 15.6332 18.0483 16.4142 18.8293L17.8284 20.2435C18.2189 20.6341 18.8521 20.6341 19.2426 20.2435C19.6332 19.853 19.6332 19.2199 19.2426 18.8293L17.8284 17.4151C17.0474 16.6341 17.0474 15.3677 17.8284 14.5867L19.2426 13.1725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a0e6320dbdbe908834ff5814593276a2.svg";
export { ForwardRef as ReactComponent };